import { DeactivateUserAlert } from '@/components/tables/users-table.deactivate.components';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import { usePermissions, UserPermissions } from '@/modules/Permissions';
import { User } from '@/modules/Users/Users.api';
import { CellContext } from '@tanstack/react-table';
import { MoreHorizontal, Pencil, Trash2, UserCheck } from 'lucide-react';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const UserTableActions = (props: CellContext<User, unknown>) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const { row } = props;
  const user = row.original;

  const canDeactivate = hasPermission(UserPermissions.DEACTIVATE_USER);

  const alertTriggerRef = useRef<HTMLDivElement | null>(null);

  const selectToggleActive = () => {
    if (canDeactivate) {
      // This is to allow the dropdown to close before triggering the alert
      alertTriggerRef.current?.click();
    }
  };

  return (
    <div className={cn('flex justify-self-center')}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onSelect={() => navigate(`/users/edit/${user.id}`)}
            disabled={!hasPermission(UserPermissions.EDIT_USER) || !user.is_active}
          >
            <Pencil />
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={selectToggleActive} disabled={!canDeactivate}>
            {user.is_active ? (
              <>
                <Trash2 />
                Deactivate
              </>
            ) : (
              <>
                <UserCheck />
                Reactivate
              </>
            )}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <DeactivateUserAlert user={user} ref={alertTriggerRef} />
    </div>
  );
};
